<template>
    <SearchControl
        v-bind="$attrs"
        :search="finder.search.bind(finder)"
        :value="value"
        @input="$emit('input', $event)"/>
</template>

<script lang="ts">
import {Location} from '@/model/api';
import LocationFinder from '@/model/LocationFinder';
import {defineComponent, inject, PropType} from 'vue';
import SearchControl from './SearchControl.vue';

export default defineComponent({
    components: {SearchControl},
    props: {
        value: {
            type: Object as PropType<Location | null>,
            default: null,
        },
    },
    emits: ['input'],
    setup() {
        const finder = inject<LocationFinder>('locationFinder')!;

        return {finder};
    },
});
</script>
